import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./assets/css/font-awesome.min.css";
import "./assets/css/animate.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/bootstrap.min.css";
import "./assets/index.scss";
import VueAwesomeSwiper from "vue-awesome-swiper";
import VueSlickCarousel from "vue-slick-carousel";

const options = {
  color: "#FFFFFF",
  failedColor: "#874b4b",
  thickness: "2px",
  transition: {
    speed: "0.2s",
    opacity: "0.6s",
    termination: 300,
  },
  autoRevert: true,
  location: "top",
  inverse: false,
};
createApp(App)
  .use(store)
  .use(router)
  .use(VueSlickCarousel)
  .use(VueAwesomeSwiper)
  .mount("#app");
